<script lang="ts">
  import { onMount } from 'svelte';
  import { session, sessionIn } from './lib/stores/session';
  import { filters } from './lib/stores/filters';
  import { api } from './lib/api';
  import { loadFeed } from './lib/stores/feed';
  import { loadBrands } from './lib/stores/brands';
  import { startStatsPoll, stopStatsPoll } from './lib/stores/stats';
  import Login from './components/Login.svelte';
  import TopBar from './components/TopBar.svelte';
  import Rail from './components/Rail.svelte';
  import Feed from './components/Feed.svelte';
  import Lightbox from './components/Lightbox.svelte';
  import Toasts from './components/Toasts.svelte';

  let sampleDismissed = $state(false);
  let lightboxId = $state<number | null>(null);

  // Session probe: /api/stats is authed, so a 2xx means the cookie is still valid.
  onMount(async () => {
    try {
      await api.stats();
      sessionIn();
    } catch {
      session.set('out'); // api.ts already flipped it on a 401; this also covers a network failure
    }
  });

  // Session-scoped side effects: brand list + stats polling, torn down on logout.
  $effect(() => {
    if ($session !== 'in') return;
    void loadBrands();
    startStatsPoll();
    return () => stopStatsPoll();
  });

  // Filter-scoped: (re)load the feed on every filter change while logged in.
  // Fires once on login — filters are still DEFAULT_FILTERS, so no double load.
  $effect(() => {
    const current = $filters;
    if ($session !== 'in') return;
    void loadFeed(current);
  });
</script>

{#if $session === 'unknown'}
  <main class="app"><p class="booting">Đang tải…</p></main>
{:else if $session === 'out'}
  <Login />
{:else}
  <div class="app">
    <TopBar />
    {#if !sampleDismissed}
      <div class="samplebar">
        <b>BẢN THỬ</b> — chưa nối eBay thật, dữ liệu là mẫu.
        <button onclick={() => (sampleDismissed = true)}>ẩn</button>
      </div>
    {/if}
    <div class="main">
      <Rail />
      <Feed lightboxOpen={lightboxId !== null} onOpen={(id) => (lightboxId = id)} />
    </div>
    <footer class="keys">
      <span><b>J</b> <b>K</b> di chuyển</span>
      <span><b>S</b> lưu</span>
      <span><b>X</b> ẩn</span>
      <span><b>O</b> mở eBay</span>
      <span><b>Enter</b> xem to</span>
      <span><b>←</b> <b>→</b> listing khác</span>
      <span><b>Esc</b> đóng</span>
    </footer>
    <Lightbox
      id={lightboxId}
      onClose={() => (lightboxId = null)}
      onNavigate={(id) => (lightboxId = id)}
    />
    <Toasts />
  </div>
{/if}

<style>
  .booting { padding: 16px; color: var(--ink-dim); }
</style>
